module.exports = __webpack_public_path__ + "assets/99d2808f3c3a421d9ddf6ee44115f2fe.mp3";